/*
 * ZAKU looping gallery: window.zkGallery(root) wires [data-gallery-prev]/[data-gallery-next]
 * on a [data-gallery] scroll-snap track (PDP main-product + quick view) so it cycles in one
 * direction. A copy of the last slide sits before the first and a copy of the first after the
 * last; when the track comes to rest on a copy it jumps (instantly) to the real slide.
 */
(function () {
  window.zkGallery = function (root) {
    if (!root || root.hasAttribute('data-gallery-ready')) return;
    root.setAttribute('data-gallery-ready', '');
    var track = root.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-gallery-slide]');
    var n = slides.length;
    if (n < 2) return;

    function copy(slide) {
      var c = slide.cloneNode(true);
      c.removeAttribute('data-gallery-slide');
      c.removeAttribute('data-media-id');
      c.setAttribute('data-gallery-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
      return c;
    }
    track.insertBefore(copy(slides[n - 1]), slides[0]);
    track.appendChild(copy(slides[0]));

    // Positions on the track: 0 = copy of the last, 1..n = real slides, n + 1 = copy of the first
    function width() { return track.clientWidth || 1; }
    function pos() { return Math.round(track.scrollLeft / width()); }
    function jump(p) { track.scrollTo({ left: p * width(), behavior: 'instant' }); }
    function settle() {
      var p = pos();
      if (p <= 0) jump(n);
      else if (p >= n + 1) jump(1);
    }
    function go(step) {
      settle();
      track.scrollTo({ left: (pos() + step) * width(), behavior: 'smooth' });
    }

    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');

    // Progress dots, left of the arrows: one per image, the current one highlighted
    var dots = [];
    if (prev) {
      var wrap = document.createElement('div');
      wrap.className = 'zk-gallery-dots';
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'zk-gallery-dots__dot';
        d.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + n);
        d.addEventListener('click', (function (p) {
          return function () { settle(); track.scrollTo({ left: p * width(), behavior: 'smooth' }); };
        })(i + 1));
        wrap.appendChild(d);
        dots.push(d);
      }
      prev.parentNode.insertBefore(wrap, prev);
    }
    function mark() {
      var p = pos();
      var real = p <= 0 ? n : p >= n + 1 ? 1 : p;
      dots.forEach(function (d, i) {
        var on = i === real - 1;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }

    jump(1);
    mark();
    var timer;
    track.addEventListener('scroll', function () {
      mark();
      clearTimeout(timer);
      timer = setTimeout(settle, 150);
    }, { passive: true });
    window.addEventListener('resize', function () { jump(Math.max(1, Math.min(n, pos()))); }, { passive: true });

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  };
})();
